import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['LOGIN_INIT', 'LOGIN_OUT', 'SET_BTNLIST']),
    handleLogin(data) {
      this.LOGIN_INIT({ user: data, token: data.token, menu: data.menu })
      const { btnList } = this.myRecursionFun(data.menu)
      this.SET_BTNLIST({ btnList })
      this.$router.push({ path: '/index' })
    },
    myRecursionFun(list, btnList = {}) {
      if (list === null) return
      const stack = [...list]
      // const btnList = {}
      while (stack.length) {
        const first = stack.shift()
        const { buttons, url, children } = first
        if (buttons && buttons.length) {
          btnList[url] = {}
          buttons.forEach(item => (btnList[url][item.toUpperCase()] = true))
        }
        // 按钮
        if (children && children.length) {
          this.myRecursionFun(children, btnList)
        }
      }
      return { btnList }
    }
  }
}